import { Nav } from "@/components/Nav";
import { Hero } from "@/components/Hero";
import { Ribbon } from "@/components/Ribbon";
import { Manifesto } from "@/components/Manifesto";
import { AppStore } from "@/components/AppStore";
import { Recommender } from "@/components/Recommender";
import { Footer } from "@/components/Footer";

export default function Home() {
  return (
    <div className="relative">
      <Nav />
      <main>
        <Hero />
        <Ribbon />
        <Manifesto />
        <AppStore />
        <Recommender />
      </main>
      <Footer />
    </div>
  );
}
